// Tournament settings store dates as YYYY-MM-DD and times as HH:mm, in Utah time.

export function formatDate(value, {withWeekday = false} = {}) {
	const [year, month, day] = value.split('-').map(Number);

	return new Date(year, month - 1, day).toLocaleDateString('en-US', {
		...(withWeekday ? {weekday: 'long'} : {}),
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
}

export function formatTime(value) {
	const [hours, minutes] = value.split(':').map(Number);

	return `${ hours % 12 || 12 }:${ String(minutes).padStart(2, '0') } ${ hours < 12 ? 'AM' : 'PM' }`;
}

// Whole dollars show as "$100", like the site always has.
export function formatPrice(amount) {
	const rounded = Math.round(amount * 100) / 100;

	return Number.isInteger(rounded) ? `$${ rounded }` : `$${ rounded.toFixed(2) }`;
}

// A one-spot tier names its sponsor in place of the price once it's taken. Bigger
// tiers count down their open spots and list their sponsors separately.
export function sponsorTierStatus({spots, sponsors = []}) {
	const unlimited = spots === null || spots === undefined;
	const remaining = unlimited ? null : Math.max(spots - sponsors.length, 0);

	return {
		remaining,
		showsRemaining: !unlimited && spots > 1 && remaining > 0,
		sponsoredInTitle: spots === 1 && sponsors.length > 0,
		soldOut: !unlimited && spots > 1 && remaining === 0,
		listsSponsors: spots !== 1 && sponsors.length > 0,
	};
}

// The tier's title as plain text, the way the sponsor page shows it.
export function sponsorTierTitle(tier) {
	const {remaining, showsRemaining, sponsoredInTitle, soldOut} = sponsorTierStatus(tier);
	const name = tier.name || 'Untitled tier';

	if (sponsoredInTitle) {
		return `${ name } - Sponsored by ${ tier.sponsors[0].name }`;
	}
	if (soldOut) {
		return `${ name } - Sold out`;
	}

	const count = showsRemaining ? ` (${ remaining } remaining)` : '';
	const price = typeof tier.price === 'number' ? ` - ${ formatPrice(tier.price) }` : '';

	return `${ name }${ count }${ price }`;
}
